import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getMarkets, addMarket } from './api';

const MarketsPage = () => {
    const { packageName } = useParams();
    const token = localStorage.getItem('token');
    const [markets, setMarkets] = useState([]);
    const [newMarketName, setNewMarketName] = useState('');
    const navigate = useNavigate();

    const fetchMarketsList = async () => {
        try {
            const data = await getMarkets(token, packageName);
            if (data.markets) setMarkets(data.markets);
            console.log(data)
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchMarketsList();
    }, [packageName]);

    const handleAddMarket = async (e) => {
        e.preventDefault();
        if (!newMarketName) return;
        try {
            await addMarket(token, packageName, newMarketName);
            setNewMarketName('');
            fetchMarketsList();
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div className="container mt-4">
            <h2>Markets for {packageName}</h2>
            <form className="mb-3 d-flex" onSubmit={handleAddMarket}>
                <input
                    className="form-control"
                    placeholder="New Market Name"
                    value={newMarketName}
                    onChange={e => setNewMarketName(e.target.value)}
                />
                <button type="submit" className="btn btn-primary ms-2">Add Market</button>
            </form>
            <table className="table">
                <thead>
                <tr>
                    <th>Market Name</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {markets.map(market => (
                    <tr key={market}>
                        <td>{market}</td>
                        <td>
                            <button className="btn btn-sm btn-info" onClick={() => navigate(`/admin/packages/${packageName}/${market}`)}>View/Edit Market</button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
            <button className="btn btn-secondary" onClick={() => navigate('/admin')}>Back</button>
        </div>
    );
};

export default MarketsPage;